export const DOCUMENT_TEMPLATE_LOAN_TYPE_OPTIONS = [
    { label: 'Conventional', value: 'Conventional' },
    { label: 'FHA', value: 'FHA' },
    { label: 'VA', value: 'VA' },
    { label: 'Jumbo', value: 'Jumbo' },
]

const LOAN_TYPE_ALIASES = {
    conventional: 'Conventional',
    fha: 'FHA',
    va: 'VA',
    jumbo: 'Jumbo',
}

export const normalizeDocumentTemplateLoanTypes = (values) => {
    const source = Array.isArray(values) ? values : [values]
    return source.reduce((loanTypes, value) => {
        const normalized =
            LOAN_TYPE_ALIASES[String(value || '').trim().toLowerCase()]
        if (normalized && !loanTypes.includes(normalized)) {
            loanTypes.push(normalized)
        }
        return loanTypes
    }, [])
}
